import { useAsyncOp } from "@indietabletop/appkit/use-async-op";
import { ReactNode, useEffect } from "react";
import { EternolDB } from "../../lib/db";
import { DatabaseOpenRequest, eternol } from "./context";
import { InaccessibleDatabaseError } from "./types";
import { toKnownError } from "./utils";

export function DatabaseProvider(props: { children: ReactNode }) {
  const { op, setSuccess, setFailure } = useAsyncOp<
    EternolDB,
    InaccessibleDatabaseError
  >();

  useEffect(() => {
    eternol.idb
      .open({
        onBlocking() {
          setFailure({ type: "CLOSED_FOR_UPGRADE" });
          eternol.idb.close();
          console.info("Database closed due to version upgrade.");
        },
      })
      .then(
        () => {
          setSuccess(eternol);
          console.info("Database open.");
        },
        (error: unknown) => {
          setFailure(toKnownError(error));
          console.warn(`Request to open database failed.`);
        },
      );

    return () => {
      eternol.idb.close();
      console.info("Database closed.");
    };
  }, [setFailure, setSuccess]);

  return (
    <DatabaseOpenRequest.Provider value={op}>
      {props.children}
    </DatabaseOpenRequest.Provider>
  );
}
